module.exports = __webpack_public_path__ + "img/loader.58fb5f75.gif";